export const createPages = (currentPage, pageCount) => {
  const range = [];
  const delta = 1;
  if (pageCount === 1) {
    range.push(currentPage);
  }
  if (pageCount <= 1) {
    return range;
  }
  for (
    let i = Math.max(2, currentPage - delta);
    i <= Math.min(pageCount - 1, currentPage + delta);
    i++
  ) {
    range.push(i);
  }

  if (currentPage - delta > 2) {
    range.unshift('...');
  }
  if (currentPage + delta < pageCount - 1) {
    range.push('...');
  }

  range.unshift(1);
  range.push(pageCount);

  return range;
};
